import type Results from '@pelckmans/elementis/components/results';
import { type ComponentProps } from 'react';
import type { ResultsScore, Score } from '../pages/material/results/api/results';

export type Result = Score & {
  memberId: string;
  nodeId: string;
};

export type Status = NonNullable<ComponentProps<typeof Results>['status']>;

export type ResultsForScorableItem = Pick<
  Result,
  'score' | 'session' | 'needsGrading' | 'duration' | 'completedBySystem' | 'isZeroScore' | 'achievedAt'
>;

/**
 * @deprecated should be retrieved from the backend
 */
export const getStatusForScorableItem = (scorableItem: ResultsForScorableItem): Status => {
  const { session, score, needsGrading, duration, completedBySystem } = scorableItem;

  if (!session || (session && duration === 0 && score.maximum === 0)) {
    return 'not-started';
  }
  if (needsGrading) {
    return 'pending-grading';
  }
  if (session && score.achievable !== score.maximum) {
    return 'busy';
  }
  if (completedBySystem) {
    return 'not-finished';
  }
  if (score.achievable === score.maximum) {
    return 'finished';
  }

  throw new Error(`Unknown status for result: ${JSON.stringify(scorableItem)}.`);
};

export const getStatusLabel = (status: Status) => {
  return `PAGES.RESULTS.PROGRESS_BAR.STATUS.${status.toUpperCase()}.A11Y_LABEL`;
};

export const getResultPercentages = (score?: ResultsScore, needsGrading?: boolean) => {
  if (!score) return { awaiting: 0, success: 0, failure: 0, undone: 100 };

  if (needsGrading) return { awaiting: 100, success: 0, failure: 0, undone: 0 };

  return {
    awaiting: 0,
    success: score.achieved,
    failure: score.achievable - score.achieved,
    undone: score.maximum - score.achievable,
  };
};
